<div class="flex flex-col h-full justify-between" *ngIf="locationLoaded">

<div class="p-1.5"  >
    <div class="flex justify-between items-start mb-0.5">
    <!-- Left Content -->
  <div class="flex-1 min-w-0">
    <h2 class="text-[#15191E] font-medium text-sm leading-5 mb-0.5 break-all line-clamp-1"
        matTooltip="{{ card?.problemLookup?.name }}">
      {{ card?.problemLookup?.name }}
    </h2>
    <p class="text-[#6B7080] font-medium text-[13px] leading-4 line-clamp-1 break-all"
      style="max-width: calc(100% - 20px);"
      matTooltip="{{ card?.ticketNoteWithAttachments?.note?.noteText }}">
      {{ card?.ticketNoteWithAttachments?.note?.noteText }}
    </p>
  </div>


    <!-- Priority Flag -->
    <ng-container>
      <svg [matTooltip]="card?.priorityLookup?.name"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="shrink-0 ml-[2px]">
        <path d="M3.21899 1.75V14.25"
              [attr.stroke]="appUtilService.getTextColor(card?.priorityLookup?.name)"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"/>
        <path
          d="M3.21899 3H10.219C11.9065 3 12.2815 3.9375 11.094 5.125L10.344 5.875C9.84399 6.375 9.84399 7.1875 10.344 7.625L11.094 8.375C12.2815 9.5625 11.844 10.5 10.219 10.5H3.21899"
          [attr.stroke]="appUtilService.getTextColor(card?.priorityLookup?.name)"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"/>
      </svg>
    </ng-container>

    <!-- Menu Icon -->
    <button *ngIf="isMenuIcon"
            class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA] mt-[-3px]  ml-[1px]"
            (click)="toggleDropdown('critical-actionDropdown' + MenuItemPreFix + card.id, $event)">
      <img src="../../../../../../assets/images/icons/tickets/three-dots.svg" alt="">
      <div class="relative">
        <div class="custom-popup -right-2 top-5 w-screen max-w-[245px]"
            [ngClass]="isDropdownVisible('critical-actionDropdown' + MenuItemPreFix + card.id) ? 'popup-active' : 'popup-inactive'"
              role="button" tabindex="0"
            (click)="onDivClick($event); $event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()">
          <ul class="text-xs text-[#252F4A] font-medium leading-[18px] text-start">
            <li [style.pointer-events]="!recurringTicketWrite? 'none' : 'auto'"
                    [style.opacity]="!recurringTicketWrite? '0.6' : '1'">
              <a href="javascript:void(0)" (click)="ticketSchedule(card.id)"
                class="mx-2.5 p-2.5 flex gap-2 items-center rounded-md hover:bg-[#f9f9f9] cursor-pointer">
                <img src="./assets/images/icons/tickets/recurring-ticket.svg" alt="">
                <span>Schedule Recurring Ticket</span>
              </a>
            </li>
            <li [style.pointer-events]="!changeWorkerWrite? 'none' : 'auto'"
                    [style.opacity]="!changeWorkerWrite? '0.6' : '1'">
              <a href="javascript:void(0)" (click)="AddTeamMemberAndHour(card)"
                class="mx-2.5 p-2.5 flex gap-2 items-center rounded-md hover:bg-[#f9f9f9] cursor-pointer">
                <img src="./assets/images/icons/tickets/add-member.svg" alt="">
                <span>Add Team Member Hours</span>
              </a>
            </li>
            <li [style.pointer-events]="!teamHoursWrite? 'none' : 'auto'"
                    [style.opacity]="!teamHoursWrite? '0.6' : '1'">
              <a href="javascript:void(0)" (click)="openTeamLogHours(card)"
                class="mx-2.5 p-2.5 flex gap-2 items-center rounded-md hover:bg-[#f9f9f9] cursor-pointer">
                <img src="./assets/images/icons/tickets/log-hours.svg" alt="">
                <span>Log Team Hours</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </button>
    </div>

    <!--Show the locations and areas for the ticket -->
    <div>
          <div class="flex mb-1 gap-1">
               <ng-container *ngFor="let loc of getSortedTicketLocations(card.id).slice(0, 1); trackBy: trackByLocationId">
  <div class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px] h-auto rounded"
       style="font-size: 10px;">
    <span>{{ loc.location.name }}</span>
    <span class="bg-[#09090B4D] rounded-full size-1"></span>

    <span>
      {{ getFirstTwoAreaNames(loc) }}
      <ng-container *ngIf="loc?.areas?.length > 1">
        <span class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px] h-auto rounded"
              style="font-size: 10px;"
              [matTooltip]="getRemainingAreasTooltip(loc)"
              matTooltipClass="multiline-tooltip"
              matTooltipPosition="above">
          +{{ loc.areas.length - 1 }}
        </span>
      </ng-container>
    </span>
  </div>
</ng-container>
                      <ng-container *ngIf="getTicketLocationsWithAreas(card).length > 1">
                      <div class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px]      h-auto           rounded  " style="font-size: 10px;"
                        [matTooltip]="getRemainingLocationsTooltip(card)" matTooltipClass="multiline-tooltip"
                        matTooltipPosition="above">
                        +{{ getTicketLocationsWithAreas(card).length - 1 }}
                      </div>
                    </ng-container>
                  </div>
    </div>


    <div class="flex justify-between items-center gap-1.5 font-medium text-xs flex-wrap">
      <div class="flex items-center gap-1.5">

        <div [matTooltip]="getLatestChangeStatus(card)?.statusLookup?.name" *ngIf="showStatus"
          class="px-0 py-0.5 rounded-sm whitespace-nowrap">
            <span class="badge !inline-flex items-center justify-center gap-1.5 shrink-0 !border-0" [ngStyle]="{
                      'background-color': appUtilService.getRandomColor(getLatestChangeStatus(card)?.statusLookup?.name),
                      'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
    }">
        <span class="inline-block rounded-full size-3 border" [ngStyle]="{
                      'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
    }"></span>
        <span [ngStyle]="{
                      'color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
    }">
          {{ getLatestChangeStatus(card)?.statusLookup?.name?.length > 8
          ? (getLatestChangeStatus(card)?.statusLookup?.name | slice:0:8) + '...'
          : getLatestChangeStatus(card)?.statusLookup?.name }}

        </span>
      </span>
          <!-- <span class="leading-4 text-[#60646C]">{{ getTotalEstimatedHours(card) * getTotalCost(card) }} $</span> -->
        </div>
        <div [matTooltip]="'Estimated Hours'"
          class="px-2 py-0.5 rounded-sm whitespace-nowrap"
          [ngClass]="getTagStyle(0)">
          <span class="leading-4 text-[#60646C]">{{ getTotalEstimatedHours(card) }} h</span>
        </div>
        </div>
      <p class="text-[#6B7080] font-medium text-[10px] leading-4">
        {{card.ticketNo}}
      </p>
    </div>

</div>

<div *ngIf="showFooter" class="p-1.5 border-t border-[#F1F1F4]">
  <div class="flex justify-between items-center">
    <div class="flex -space-x-2">
      <app-avatar
        [userList]="ticketLaborUserList(card)"
        size="sm">
      </app-avatar>
    </div>
    <p class="font-medium text-xs leading-4 text-[#6B7080]">
      Due Date:
      <span class="ms-1">
        {{card.dueDate ? (card.dueDate | date: 'MM/dd/yy HH:mm'): 'No due date' }}
      </span>
    </p>
  </div>
</div>
</div>




